import React from "react";
import { FormattedMessage } from "react-intl";
import { Space } from "@masterteam/mt-design-react";

import useIsAr from "../../Hooks/useIsAr";

import { ReactComponent as KPIStatusIcon } from "../../assets/images/circle.svg";

import styles from "./KPIStatusIndicator.module.scss";

function getOperator(str) {
  if (str === ">=") {
    return "≥";
  } else if (str === "<=") {
    return "≤";
  }
  return str;
}

function generateCalculation(item) {
  if (!item.Min && !item.Max) return null;
  return (
    <span>
      (
      {`${item.Min || ""} ${
        item.Min ? getOperator(item.MinOperator) || "" : ""
      } `}
      <FormattedMessage id="chart-q.value" />
      {` ${item.Max ? getOperator(item.MaxOperator) || "" : ""} ${
        item.Max || ""
      }`}
      )
    </span>
  );
}

function KPIStatusIndicator({ item, list = [], status, showCalculation }) {
  const [isAr] = useIsAr();
  const _item = item || list.find((listItem) => listItem.Code === status);

  return (
    <Space align="center" className={styles.kpiStatus} gap={4}>
      <KPIStatusIcon fill={_item?.Color} />
      <span>
        {isAr ? _item?.ArabicName : _item?.EnglishName}{" "}
        {showCalculation && generateCalculation(item)}
      </span>
    </Space>
  );
}

export default KPIStatusIndicator;
